module.exports = __webpack_public_path__ + "static/media/Upload.c469f49a.svg";